import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-big-data-plan',
  templateUrl: './big-data-plan.component.html',
  styleUrls: ['./big-data-plan.component.sass']
})
export class BigDataPlanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
